import { useEffect, useState, useCallback } from "react";
import { IProps, MessageResponse } from "./types";
import { useStyles } from "../../../style/styles";
import { Grid, ThemeProvider } from "@mui/material";
import theme from "../../../theme";
import ChatList from "../ChatList";
import * as utils from '../../../lib/messageUtils'
import ChatInput from "../ChatInput";
import Navbar from "../Navbar";
import messagingService from "../../../services/MessagingService";

const Chat = (props: IProps) => {
  const classes = useStyles()
  const { user, channel } = props
  const [initialNextToken, setInitialNextToken] = useState<string | null>(null)
  const [messageUpdateTrigger, setMessageUpdateTrigger] = useState<number>(0)

  const handleLoadMessages = useCallback(async () => {
    console.log('v2: triggering message reload')
    setMessageUpdateTrigger(prev => prev + 1)
  }, []);

  const callbackProcessor = useCallback(async(message: MessageResponse) => {
    const messageType = message?.headers['x-amz-chime-event-type']
    const record = JSON.parse(message?.payload)
    const isRecordNotEmpty = record && record?.Content

    console.log('v2: callbackProcessor triggered', messageType, record)
    console.log('v2: Current channel ARN:', channel?.channelArn)

    switch(messageType) {
      case 'CREATE_CHANNEL_MESSAGE':
        console.log('v2: CREATE_CHANNEL_MESSAGE received', record)
        if (record.Type === 'CONTROL' || record.Persistence === 'NON_PERSISTENT') {
          console.log('v2: Skipping CONTROL or NON_PERSISTENT message')
          return
        }
        if(isRecordNotEmpty) {
          console.log('v2: Comparing ARNs - Record:', record?.ChannelArn, 'Current:', channel?.channelArn)
          if (record?.ChannelArn === channel?.channelArn) {
            console.log('v2: New message received for current channel, triggering reload', record)
            handleLoadMessages()
          } else {
            console.log('v2: Message is for a different channel, ignoring')
          }
        }
        break
      case 'UPDATE_CHANNEL_MESSAGE':
      case 'REDACT_CHANNEL_MESSAGE':
        if (record?.ChannelArn === channel?.channelArn) {
          console.log('v2: Message updated/redacted, triggering reload')
          handleLoadMessages()
        }
        break
      case 'UPDATE_CHANNEL':
      case 'CREATE_CHANNEL_MEMBERSHIP':
        if (record?.ChannelArn === channel?.channelArn) {
          console.log('v2: Channel updated, triggering reload')
          handleLoadMessages()
        }
        break
    }
  }, [channel?.channelArn, handleLoadMessages])

  // Subscribe to messaging service updates
  useEffect(() => {
    console.log('v2: Subscribing to message updates for channel:', channel?.channelArn)
    messagingService.subscribeToMessageUpdate(callbackProcessor)
    return () => {
      console.log('v2: Unsubscribing from message updates')
      messagingService.unsubscribeFromMessageUpdate(callbackProcessor)
    }
  }, [callbackProcessor])

  return (
      <>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700"/>
        <ThemeProvider theme={theme}>
          <div className={classes.mainContainer}>
            <Grid container direction='column'>
              {/* NAVBAR */}
              <Grid item>
                <Navbar />
              </Grid>

              {/* CHAT BODY */}
              <Grid item>
                <div className={classes.chatBody}>
                  <ChatList
                    onLoadMessages={handleLoadMessages}
                    inputFocused={false}
                    channelMetadata={channel.metadata ? JSON.parse(channel.metadata) : null}
                    user={user}
                    channel={channel}
                    initialNextToken={initialNextToken}
                    messageUpdateTrigger={messageUpdateTrigger}
                  />
                </div>
              </Grid>

              {/* CHAT INPUT */}
              <ChatInput
                channel={channel}
                user={user}
                onFocus={() => {}}
              />
            </Grid>
          </div>
        </ThemeProvider>
      </>
    )
}

export default Chat